import { useQuery } from '@apollo/client';
import * as Schema from 'generated/graphql/schema';
import { FunctionComponent, useState } from 'react';

import LoadingOrError from '@/components/loading/loading-or-error';
import { andonListSettings } from '@/graphql/queries';
import AndonMain from '@/views/andon/main';

const AndonPage: FunctionComponent = () => {
  const { data, loading, error } = useQuery<Schema.AndonListSettingsQuery, Schema.AndonListSettingsQueryVariables>(
    andonListSettings,
    {
      ssr: false,
      errorPolicy: 'all',
      fetchPolicy: 'no-cache',
    },
  );

  const [andonSettings] = data?.andon ?? [undefined];

  // TODO: We may update the selected company (settings) if that is the desire.
  const [settings = andonSettings] = useState(andonSettings);

  const { companyId } = settings || {};

  // FIXME: If companyId is undefined here, it means that the Andon service
  // couldn't determine any companies for the current user. In that case, we should
  // render a not-permitted page.

  if (loading || !companyId) {
    return <LoadingOrError loading={loading} error={error} />;
  }

  return <AndonMain companyId={companyId} />;
};

export default AndonPage;
